'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getErrorMessage = require('./get-error-message');
var _getErrorMessage2 = _interopRequireDefault(_getErrorMessage);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function () {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Please let us know your phone number';
  return function (number) {
    if (/^0[12378]\d{8,9}$/.test(number)) {
      return '';
    }
    return (0, _getErrorMessage2.default)(errorMessage, {
      value: number
    });
  };
};